import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events, AlertController } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';
import * as moment from 'moment';

@Component({
  selector: 'page-training',
  templateUrl: 'training.html',
  providers : [HttpClient, CustomToast]
})
export class TrainingPage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  training = {
    id : -1,
    name : '',
    date_start : '',
    date_end : '',
    place : '',
    link : '',
    description: ''
  };

  pdfs? = {
    id: -1,
    path: '',
    originialname: ''
  }


  filesToUpload?: any;
  tags = '';
  customToast : CustomToast;
  events : Events;
  alertCtrl : AlertController;

  minDate = moment().subtract(20,'years').toISOString();
  maxDate = moment().add(20,'years').toISOString();

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events, alertCtrl : AlertController) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.customToast = customToast;
    this.events = events;
    this.alertCtrl = alertCtrl;
    let id = navParams.get('id');
    this.httpCallTraining(id);
    this.httpCallTrainingPdf(id);
	}

  httpCallTraining(id){
    this.httpClient.get('/trainings/'+id,(error,data)=>{
      if(!error){
        this.training = data.json();
        this.httpCallTrainingPdf(id);
      }
    });
  }

  selectFile(fileInput: any){
    this.filesToUpload = <File> fileInput.target.files;
    console.log(this.filesToUpload)
  }


  httpCallTrainingPdf(id:number){
    this.httpClient.get('/trainingPdf/'+id,(error,data)=>{
      if(!error && data._body.length){
        this.pdfs = data.json();
        this.filesToUpload =this.pdfs.originialname
      
      }
    });
  }

  httpUpdateTraining(){
    this.training.date_start = this.training.date_start.split('T')[0];
    this.training.date_end = this.training.date_end.split('T')[0];
    this.httpClient.put('/trainings',this.training,(error,data)=>{
      if(!error){
        if(this.filesToUpload){
          this.httpPostTrainingPdf()
        }else{
          this.customToast.showMessage('Formación actualizada correctamente',2000);
          this.navCtrl.pop();
          this.events.publish('training:update');
        }
       }     
    });
  }

  httpPostTrainingPdf(){
    this.httpClient.delete('/trainingPdf/'+this.training.id,(error,data)=>{
      if(!error){
        this.httpClient.upload('/trainingPdf',this.filesToUpload, this.tags, this.training.id, (data: any)=>{
          this.customToast.showMessage('Frormación actualizada correctamente',2000);
          this.navCtrl.pop();
          this.events.publish('training:update');
        });
      }
    }); 
   
  }

  onClickSave(){
    this.httpUpdateTraining();
  }

  onClickDelete(){
    let alert = this.alertCtrl.create({
      title : '¿Estas seguro?',message : 'Vas a eliminar la información de esta formación',
      buttons:[{
        text : 'No',
        role : 'cancel'
        },
        {
        text : 'Si',
        role : 'confirm',
          handler : ()=>{
            this.httpCallDelete();
          }
        }
      ]
    });
    alert.present();
  }

  httpCallDelete(){
    this.httpClient.delete('/trainings/'+this.training.id,(error,data)=>{
      if(!error){
        this.httpClient.delete('/trainingPdf/'+this.training.id,(error,data)=>{
        this.customToast.showMessage('Formación eliminada correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('training:delete');
      });
      }
    });
  }

  onClickDeleteFile(){
    let alert = this.alertCtrl.create({
      title : '¿Estas seguro?',message : 'Vas a eliminar el archivo adjunto de esta formación',
      buttons:[{
        text : 'No',
        role : 'cancel'
        },
        {
        text : 'Si',
        role : 'confirm',
          handler : ()=>{
            this.httpCallDeleteFile();
          }
        }
      ]
    });
    alert.present();
  }

  httpCallDeleteFile(){
    this.httpClient.delete('/trainingPdf/'+this.training.id,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Archivo eliminado correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('training:delete');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/trainings/training/training.ts